import styled from "styled-components";

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.owner-field > div, &.owner-field > div > div {
    width: 100%;
  }
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.red};
  font-size: 12px;
  margin-top: 4px;
  width: 100%;
`;
